import { LATEST_COLLECTION_IMAGE } from "@/lib/brand";
import { Sparkles } from "lucide-react";

export default function LatestCollection() {
  return (
    <section
      data-testid="latest-collection-section"
      className="relative py-24 md:py-32 canvas-soft"
    >
      <div className="mx-auto max-w-6xl px-6 md:px-10">
        <div className="relative overflow-hidden rounded-[36px] sb-shadow-lg group">
          <img
            src={LATEST_COLLECTION_IMAGE}
            alt="Latest collection"
            loading="lazy"
            className="w-full h-[540px] object-cover transition-transform duration-1000 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/25 to-transparent" />
          <div className="sb-ribbon flex items-center gap-1.5">
            <Sparkles size={12} strokeWidth={2.5} /> NEW ARRIVAL
          </div>

          <div className="absolute inset-x-0 bottom-0 p-8 md:p-14">
            <span className="inline-block text-xs tracking-[0.28em] uppercase font-semibold text-white/70">
              This week
            </span>
            <h3 className="mt-3 font-display font-black text-white text-4xl md:text-6xl leading-tight tracking-tight max-w-3xl">
              Fresh on our shelves this week.
            </h3>
            <p className="mt-4 text-white/85 text-lg leading-relaxed max-w-2xl">
              Step inside to explore our newest arrivals and discover the
              complete collection in person.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
